<div class="loading">
    <h2>Please wait a while...</h2>
</div>
